// Clickable Sequesign lockup (dark-surface variant). Used in the
// signup shell, the "not configured" stub, and the authenticated
// header. Links back to sequesign.com so the dashboard reads as a
// product surface of the Sequesign brand rather than a standalone
// service.

export function Wordmark(props: { text?: string }) {
  // The h1 restores document semantics (screen-reader heading
  // navigation) lost when the wordmark became a bare anchor (triage
  // P2#1). .wordmark-heading neutralizes h1 default sizing so the
  // header layout is unchanged.
  return (
    <h1 className="wordmark-heading">
      <a href="https://sequesign.com" className="wordmark-link" aria-label="Sequesign home">
        <img
          src="/sequesign-logo-dark.svg"
          alt="Sequesign"
          className="wordmark-mark"
          width="155"
          height="32"
        />
        {props.text ? <span className="wordmark">{props.text}</span> : null}
      </a>
    </h1>
  );
}
